import React from 'react';
import Logo from './../Logo/Logo';
import NavList, { NavListItemMap } from '../NavList/NavList';
import './CommonNav.scss';
import Search from '../Search/Search';

const CommonNav: React.FunctionComponent<{}> = React.memo(() => {
    const navItems: NavListItemMap[] = [
        { activeClassName: 'active-route', className: '', exact: true, label: 'Inicio', to: '/' },
        { activeClassName: 'active-route', className: '', exact: true, label: 'Productos', to: '/productos' },
        { activeClassName: 'active-route', className: '', exact: true, label: 'Contacto', to: '/contacto' }
    ];

    return (
        <div className="CommonNavContainer">
            <div className="container">
                <Logo className="LogoContainer" />
                <Search />

                <div className="NavContainer">
                    <NavList items={navItems} className="CommonNavLinks" />
                </div>
            </div>
        </div>
    );
});

export default CommonNav;